import React from 'react'
import { LinearProgress, Box, Grid } from '@mui/material'
import ComponentImage from 'components/Image/Image'

import { LogoContainer } from './styles'

import { Title } from 'components'
import { COLORS } from 'utils'
import LogoCSN from 'assets/images/logo_csn_horizontal.svg'

interface FullScreenLoadingProps {
  title?: string
}

const FullScreenLoading: React.FC<FullScreenLoadingProps> = ({ title }) => {
  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: '100vh' }}
    >
      <LogoContainer>
        <ComponentImage src={LogoCSN} objectFit="fill" />
      </LogoContainer>
      <Box mb={'50px'} mt={'50px'} sx={{ width: '40%' }}>
        <LinearProgress />
      </Box>
      {title && <Title fontcolor={COLORS.blueFonts}>{title}</Title>}
    </Grid>
  )
}

export default FullScreenLoading
